'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = injectDynamicAdContent;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Function to inject dynamic ad content. Dynamic ad content that needs to render a script
 * tag in order to render properly cannot be inserted via innerHtml.
 *
 *  "When inserted using the document.write() method, script elements execute..., but when
 *  inserted using innerHTML and outerHTML attributes, they do not execute at all."
 *  - From w3c Script spec (http://w3c.github.io/html/semantics-scripting.html#the-script-element)
 *
 * Instead, we create an iframe and then write the content to the iframe so that all of the
 * dynamic ad content is evaluated properly.
 *
 * @param divContainer {HTMLDivElement} - container for iframe
 * @param adContent {string} - the ad content to write to the iframe
 * @param width {number} - width of ad
 * @param height {number} - height of ad
 */
function injectDynamicAdContent(divContainer, adContent, width, height) {
  var outdatedContent = divContainer.firstChild;
  if (outdatedContent) {
    divContainer.removeChild(outdatedContent);
  }

  /* eslint-disable no-undef */
  var div = document.createElement('div');
  var iframe = document.createElement('iframe');
  /* eslint-enable no-undef */

  // Need to put a valid source attribute for the iframe so IE doesn't complain:
  // https://html.spec.whatwg.org/multipage/iframe-embed-object.html#the-iframe-element:about:blank
  iframe.src = 'about:blank';

  iframe.style.display = 'inline-block';
  iframe.style.width = width + 'px';
  iframe.style.height = height + 'px';

  div.appendChild(iframe);

  divContainer.appendChild(div);

  // Documentation for IFrame ContentWindow:
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/contentWindow
  var iFrameDocument = iframe.contentWindow && iframe.contentWindow.document;

  // Remove the margin on the document body so that the ad content sits flush with
  // the iframe container.
  var content = '<body style="margin: 0">' + adContent + '</body>';

  iFrameDocument.open();
  iFrameDocument.write(content);
  iFrameDocument.close();

  return (0, _get2.default)(iframe, 'contentWindow.document.body');
}